import React from "react";

const features = [
  {
    title: "Best Price Guarantee",
    desc: "We match any lower price.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"
        />
      </svg>
    ),
  },
  {
    title: "Free Cancellation",
    desc: "Cancel up to 48h before pick-up.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M7 7h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2zM9 16l6-6M9 10l6 6"
        />
      </svg>
    ),
  },
  {
    title: "24/7 Support",
    desc: "We're here whenever you need us.",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-5 w-5 text-[#22c55e]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2zM9 7h6M9 11h6"
        />
      </svg>
    ),
  },
];

const WhyRentGurus = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-12 bg-white font-sans">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6 lg:gap-4">
        
        {/* Left Headline Branding Block */}
        <div className="max-w-md flex-shrink-0">
          <h2 className="text-[20px] md:text-[32px] font-bold tracking-tight text-[#071c2c] leading-[1.2]">
            Why Rent Gurus?
            <span className="hidden md:block mt-1">
              More value <span className="text-[#071c2c]">.</span> Less stress <span className="text-[#071c2c]">.</span>
            </span>
          </h2>
        </div>

        {/* Right Feature Items List / Mobile Grid */}
        <div className="grid grid-cols-3 gap-2 sm:gap-4 md:gap-6 lg:gap-12 w-full lg:max-w-4xl">
          {features.map((item, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center justify-center text-center p-3 sm:p-5 border border-gray-200 rounded-2xl bg-white md:border-none md:p-0 md:bg-transparent md:flex-row md:items-start md:text-left gap-2 md:gap-3.5"
            >
              
              {/* Circular Light Green Icon Wrapper */}
              <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#e6fcf2] flex items-center justify-center">
                {item.icon}
              </div>

              {/* Feature Content */}
              <div className="flex flex-col items-center md:items-start">
                <h4 className="text-[12px] sm:text-[14px] md:text-[15px] font-bold md:font-semibold text-[#0f172a] mb-0.5 leading-tight">
                  {item.title}
                </h4>
                {/* Description is hidden on mobile to match your screenshot layout */}
                <p className="hidden md:block text-[13px] text-text-muted font-normal leading-relaxed">
                  {item.desc}
                </p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default WhyRentGurus;